import type { CSSProperties, MouseEvent, PropsWithChildren } from 'react';

import { Button } from '#/components/Button/Button';

type Props = {
  open?: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  qaId?: string;
  style?: CSSProperties;
};

export function ExpandButton({
  open,
  onClick,
  children,
  qaId,
  style,
}: PropsWithChildren<Props>) {
  return (
    <Button
      qaId={qaId}
      type="button"
      variant="tertiary"
      onClick={onClick}
      icon={{
        type: 'normalized',
        name: open ? 'chevron-up' : 'chevron-down',
        color: 'brandBlue',
        size: 16,
        position: 'right',
      }}
      style={style}
    >
      {children}
    </Button>
  );
}
